import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { authSelector, verifyUser } from '../features/auth/authSlice';
import { getDefaultPageByRole } from './routerDefinition';

const RequireAuth = ({ children, roles = [] }: { children: JSX.Element; roles?: string[] }) => {
  const dispatch = useDispatch();
  const selectAuth = useSelector(authSelector);
  const location = useLocation();
  console.log('RequireAuth at location', location.pathname, location.search);

  const allowedRole = useMemo(() => {
    if (roles.length === 0) {
      return true;
    }

    return roles.includes(selectAuth.user?.role || '');
  }, [roles, selectAuth]);

  // Require authentication
  const isLoggedIn = selectAuth.accessToken;
  if (!isLoggedIn) {
    console.log('User not logged in, redirecting to login page');
    return <Navigate to="/login" replace={true} state={{ from: location }} />;
  }

  if (!selectAuth.verifyUser) {
    console.log('Verifying user with ID:', selectAuth.user?.id);
    dispatch(verifyUser(selectAuth.user?.id));
  }

  if (!allowedRole) {
    const defaultPage = getDefaultPageByRole(selectAuth.user?.role);
    console.log('Redirecting to default page for role:', selectAuth.user?.role, defaultPage);
    return <Navigate to={defaultPage} replace={true} />;
  }

  return children;
};

export default RequireAuth;
